export default __webpack_public_path__ + "static/media/plants.456e485e.png";